import { signInWithEmailAndPassword } from 'firebase/auth'
import { auth } from '../../firebase/firebase'

export default async function firebaseLoginEmail({ email, password }: { email: string; password: string }) {
  return await signInWithEmailAndPassword(auth, email, password)
    .then(userCredential => {
      const user = userCredential.user
      return user
    })
    .catch(error => {
      return (error = {
        code: error.code,
        message: error.message,
      })
    })
}
